@if(loadingState) {
  <app-fs-loading-state/>
} @else {
  <div class="flex flex-col gap-1.25">
    <app-fund-strategy-selector
      data-qa="fs-model-selector"
      [data]="fsModels"
      [selectedItem]="selectedModel"
      [organization]="selectedOrganization"
      [buttons]="buttonsProps"
      (buttonClicked)="buttonClicked($event)"
      (selectedItemChanged)="selectedModelChanged($event)"
      (exportExcelEmitter)="exportExcel()"
      (inputChanged)="modelName = $event">
    </app-fund-strategy-selector>
    <div class="flex flex-col gap-1.25">
      <span class="font-2 bold600">Settings</span>
      @if (metrics) {
        <app-fund-strategy-settings-inputs
          [isModelBlocked]="isModelBlocked"
          [metricsData]="metrics"
          [fundStrategy]="selectedModel"
          (inputsSaveEmitter)="saveMetrics($event)">
        </app-fund-strategy-settings-inputs>
      }
      <app-fund-strategy-table
        [saveModel]="buttonsProps.apply"
        [isModelBlocked]="isModelBlocked"
        [modelName]="selectedModel?.name"
        [groups]="selectedModel?.groups"
        [metricsData]="metrics"
        (exportExcelEmitter)="saveDataForExportExcel($event)"
        (updateModelEmitter)="handleSaveGroups($event)"
        (showRoundsEmitter)="showRoundsTable = $event">
      </app-fund-strategy-table>
      @if (!showRoundsTable) {
        <span class="font-2 bold600">Analytics</span>
        <app-fund-strategy-analytics [isModelBlocked]="isModelBlocked" [analyticsData]="analyticsData"/>
        <span class="font-2 bold600">Exit analytics</span>
        <app-fund-strategy-charts [fsGroups]="groupsFS" [isModelBlocked]="isModelBlocked"></app-fund-strategy-charts>
      }
    </div>
  </div>
}
